var exports = {
  "GF": "ReportFlowPreview.module__messageScroller___UHZVQj",
  "BK": "ReportFlowPreview.module__messageContent___UHZVQj",
  "Kg": "ReportFlowPreview.module__userCard___UHZVQj",
  "fz": "ReportFlowPreview.module__userText___UHZVQj",
  "nT": "ReportFlowPreview.module__userName___UHZVQj",
  "a1": "ReportFlowPreview.module__userTag___UHZVQj",
};

module.exports = exports;
